var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconDocument(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 248,
    height: 56,
    viewBox: "0 0 248 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M114 16V12.288C114 9.26133 116.253 6.69333 119.269 6.44267C120.265 6.36267 121.264 6.29156 122.267 6.22933M122.267 6.22933C122.645 5.00431 123.406 3.9327 124.438 3.17159C125.469 2.41047 126.718 1.99988 128 2H132C133.282 1.99988 134.531 2.41047 135.562 3.17159C136.594 3.9327 137.358 5.00431 137.736 6.22933M122.267 6.22933C122.091 6.79111 122.002 7.38133 122 8V10H138V8C137.998 7.38133 137.912 6.79111 137.736 6.22933M134 44H140C141.591 44 143.117 43.3679 144.243 42.2426C145.368 41.1174 146 39.5913 146 38V12.288C146 9.26133 143.747 6.69333 140.731 6.44267C139.733 6.35985 138.735 6.28873 137.736 6.22933M134 46V41C134 38.6131 133.052 36.3239 131.364 34.636C129.676 32.9482 127.387 32 125 32H121C120.204 32 119.441 31.6839 118.879 31.1213C118.316 30.5587 118 29.7957 118 29V25C118 22.6131 117.052 20.3239 115.364 18.636C113.676 16.9482 111.387 16 109 16H106M110 16H105C103.344 16 102 17.344 102 19V51C102 52.656 103.344 54 105 54H131C132.656 54 134 52.656 134 51V40C134 33.6348 131.471 27.5303 126.971 23.0294C122.47 18.5286 116.365 16 110 16Z",
    stroke: "#60A5FA",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDocument);
export default __webpack_public_path__ + "static/media/icon-document.62075d188d4183cc0284bf37582fcef7.svg";
export { ForwardRef as ReactComponent };